export default __webpack_public_path__ + "static/media/Front-Sheyaaka-Production-House-3.b2ee6cf8.jpg";